export default {"src":"/_next/static/media/chat-icon.4a8f332f.svg","height":16,"width":16};